export default "__VITE_ASSET__CIH8KE4f__"